import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";

import { environment } from '../../../../environments/environment';
import { SavingstransactionService } from "../savingstransaction.service";

@Injectable({
  providedIn: 'root'
})
export class PrintsavingstransactionlistserviceService {

  
  private TransactionList: any[]=[];

  constructor(private savingstransactionService: SavingstransactionService,
    private datePipe: DatePipe) { }

  private getBaseUrl() {

    return environment.baseUrl;
  }

  GenerateReport(ToReceiptForm:any, savingsTransactionItem: any) {

    this.savingstransactionService.FetchSavingsTransactionById(savingsTransactionItem)
      .toPromise()
      .then(data => {
        this.TransactionList = data;
        this.ReportGenerateList(this.TransactionList, this.datePipe);
      })
      .catch(err => { console.log(err) });
  }

  private ReportGenerateList(TransactionList , datePipe: DatePipe) {

    let pdf = new jsPDF('p', 'pt', 'A4');
    let pageHeight: number = + pdf.internal.pageSize.height;

    pdf.setProperties({
      title: 'Savings Receipt',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    let todayDate = new Date();
    let height: number = 0;
    let TransactionListPageHeight: number = 0;

    for (var i = 0; i < 1; i++) {

      if (TransactionListPageHeight >= pageHeight) {
        pdf.addPage();
        TransactionListPageHeight = 0
        height = 0; // Restart height position
      }

      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(14);
      pdf.setFont('arial', 'normal');
      pdf.text("Society For Rural Improvements", 220, 40 + height);  // 40 is the height
      pdf.text("Branch :" + TransactionList[i].CustomerBranchName.toString() + ' / ' +
                            TransactionList[i].CentreName.toString(), 25, 100 + height);
      pdf.text("Cash Receipt", 425, 100 + height);

      pdf.setLineWidth(1.2);
      pdf.line(5, 105 + height, 590, 105 + height)

      pdf.setFontSize(12);
      pdf.setFont('arial', 'normal');

      pdf.text("Rct No. : " + TransactionList[i].TransactionNo.toString(), 25, 130 + height);
      pdf.text("Rct date : " + datePipe.transform(TransactionList[i].TransactionDate, 'yyyy-MM-dd').toString(), 125, 130 + height);
      pdf.text("Credit", 450, 130 + height);
      pdf.text("Received from : " + TransactionList[i].SchemeName.toString(), 25, 150 + height);

      pdf.text(TransactionList[i].AmountInWords.toString(), 25, 170 + height);

      pdf.text("Loan Receipt No: " + TransactionList[i].TransactionNo.toString()
        + TransactionList[i].Id.toString()
        + "  Recieved from " + TransactionList[i].CustomerName.toString()
        + "  Loan No. " + TransactionList[i].SavingsId.toString(), 25, 200 + height)

      pdf.line(5, 210 + height, 590, 210 + height)   // x-axis, -x-axix,  y-axis  , -y-axix

      pdf.text("Rs. " + TransactionList[i].PrincipleAmount.toString(), 25, 230 + height);
      pdf.text("For Society For Rural Improvements ", 400, 230 + height);

      pdf.text("Signature ", 35, 260 + height);
      pdf.text("Cashier ", 235, 260 + height);
      pdf.text("Manager ", 435, 260 + height);

      height = height + 270;
      TransactionListPageHeight = height + 40;  // pageHeight is 841.89  so add 40 to TransactionListPageHeight(810)      
    }
      pdf.output('dataurlnewwindow');
  }

}
